import { render, staticRenderFns } from "./AttestationComponent.vue?vue&type=template&id=aa8d0de0&scoped=true"
import script from "./AttestationComponent.vue?vue&type=script&lang=js"
export * from "./AttestationComponent.vue?vue&type=script&lang=js"
import style0 from "./AttestationComponent.vue?vue&type=style&index=0&id=aa8d0de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8d0de0",
  null
  
)

export default component.exports